import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { REVIEWS_REVIEWS_CONTAINER } from '../../constants'

const BazaarVoiceReviews = ({ className }) =>
  <Fragment>
    <div data-at-bazaarvoice-container className={ className } id={ REVIEWS_REVIEWS_CONTAINER } />
  </Fragment>

BazaarVoiceReviews.propTypes = {
  className: PropTypes.string
}

export default BazaarVoiceReviews
